
import ResourceList from '@shell/components/ResourceList/index.vue';

export default {
  name:       'KubewardenResourcedList',
  components: { ResourceList },
};
